(function() {
'use strict';

angular
    .module('core')
    .directive('lightboxMapTrigger', lightboxMapTrigger);

function lightboxMapTrigger(broker) {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            element: '=',
            searchId: '@',
            showInfoWindow: '@'
        },
        link
    };

    function link(scope, el) {
        const showInfoWindow = scope.showInfoWindow !== 'false';

        el.on('click', () => {
            broker.publish('MAPLIGHTBOX', {
                hotel: scope.element,
                searchId: scope.searchId,
                showInfoWindow
            });
        });

        scope.$on('$destroy', function() {
            el.off('click');
        });
    }
}
})();
